import { takeLatest, call, put, select } from 'redux-saga/effects'
import * as actions from './actions'
import { startLoading, stopLoading, enqueueSnackbar } from '../root/actions'
import axios from 'axios'
import { getSagasMsgs } from '../root/selectors'

export const watchRegisterSaga = [
    takeLatest(actions.USER_REGISTER_REQUEST, registerUser),
    takeLatest(actions.CUSTOMER_REGISTER_REQUEST, registerCustomer)
]

function* registerUser(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(registerUserRequest, action.userBody)
        yield put(actions.userRegisterSuccess(response))
        yield put(enqueueSnackbar({
            message: sagasMsgs.registerUserRes,
            options: {
                variant: 'success'
            }
        }))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.userRegisterError())
        yield put(enqueueSnackbar({
            message: sagasMsgs.registerUserEx,
            options: {
                variant: 'error'
            }
        }))
        yield put(stopLoading())
    }
}

async function registerUserRequest(userBody) {
    const response = await axios.post(`${process.env.API_URL}/users/reg`, userBody)
    return response.data
}

function* registerCustomer(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(registerCustomerRequest, action.customerBody)
        yield put(actions.customerRegisterSuccess(response))
        yield put(enqueueSnackbar({
            message: sagasMsgs.registerCustomerRes,
            options: {
                variant: 'success'
            }
        }))
        yield put(enqueueSnackbar({
            message: sagasMsgs.pleaseUseEmail,
            options: {
                variant: 'info'
            }
        }))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.customerRegisterError())
        yield put(enqueueSnackbar({
            message: sagasMsgs.registerCustomerEx,
            options: {
                variant: 'error'
            }
        }))
        yield put(stopLoading())
    }
}

async function registerCustomerRequest(customerBody) {
    const response = await axios.post(`${process.env.API_URL}/customers/reg`, customerBody)
    return response.data
}
